import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import LoginPage from './pages/LoginPage';
import FeedPage from './pages/FeedPage';
import AdminPage from './pages/AdminPage';
import StatisticsPage from './pages/StatisticsPage';
import UserActivityPage from './pages/UserActivityPage';
import PendingPage from './pages/PendingPage';
import AboutPage from './pages/AboutPage';
import TagsPage from './pages/TagsPage';
import TutorialPage from './pages/TutorialPage';
import ShareUploadPage from './pages/ShareUploadPage';
import NotificationsPage from './pages/NotificationsPage';
import RecycleBinPage from './pages/RecycleBinPage';
import Layout from './components/Layout';

function App() {
  const { isAuthenticated, isAdmin, isMember, isPending } = useAuthStore();

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        
        {/* PWA Share Target - needs to be accessible before full auth check */}
        <Route path="/share-upload" element={<ShareUploadPage />} />
        
        {/* Protected routes */}
        <Route element={<Layout />}>
          {isAuthenticated && isPending && (
            <Route path="/pending" element={<PendingPage />} />
          )}
          
          {isAuthenticated && (isMember || isAdmin) && (
            <>
              <Route path="/feed" element={<FeedPage />} />
              <Route path="/tags" element={<TagsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/tutorial" element={<TutorialPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/" element={<Navigate to="/feed" replace />} />
            </>
          )}

          {/* Admin route - AdminPage component has its own security check */}
          <Route path="/admin/users" element={<AdminPage />} />
          
          {/* Statistics route - StatisticsPage has its own superadmin security check */}
          <Route path="/statistics" element={<StatisticsPage />} />
          <Route path="/statistics/user/:userId" element={<UserActivityPage />} />
          
          {/* Recycle Bin route - RecycleBinPage has its own superadmin security check */}
          <Route path="/recycle-bin" element={<RecycleBinPage />} />
        </Route>

        {/* Default redirects */}
        <Route
          path="*"
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : isPending ? (
              <Navigate to="/pending" replace />
            ) : isAuthenticated && !isMember && !isAdmin && !isPending ? (
              <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center px-4">
                <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                  <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <span className="text-4xl">⏳</span>
                  </div>
                  
                  <h1 className="text-2xl font-bold text-gray-900 mb-4">
                    Awaiting Approval
                  </h1>
                  
                  <p className="text-gray-600 mb-6">
                    Thank you for registering! Your account is pending approval from a family administrator.
                  </p>
                  
                  <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
                    <p className="text-sm text-amber-800">
                      You'll receive an email once your account has been approved and you can start sharing photos with the family.
                    </p>
                  </div>

                  <button
                    onClick={() => {
                      useAuthStore.getState().clearAuth();
                      window.location.href = '/login';
                    }}
                    className="w-full px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Sign Out
                  </button>
                </div>
              </div>
            ) : (
              <Navigate to="/feed" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

